const getters = {
  // 菜单栏折叠状态
  sidebarFoldState: state => state.common.sidebarFoldState,
  // 设置页头尾部文字
  pageHeaderAppendText: state => state.common.pageHeaderAppendText,
  // 系统设置信息
  systemSetData: state => state.common.systemSetData,
  // 权限数据来源
  authFromLocal: state => state.permission.authFromLocal,
  // 全部路由
  routes: state => state.permission.routes,
  // 全部功能权限
  buttons: state => state.permission.buttons,
  // 客户类型
  isPlatform: state => state.permission.isPlatform,
  // 语言
  language: state => state.themeAndLanguage.language,
  // 主题色
  theme: state => state.themeAndLanguage.theme,
  // 主题风格
  themeType: state => state.themeAndLanguage.themeType,
  // 主题颜色
  themeColors: state => state.themeAndLanguage.themeColors,
  // 设置当前所选组织id
  orgId: state => state.orgTree.orgId,
  // 设置当前所选组织级别
  orgLevel: state => state.orgTree.orgLevel,
  // 设置所选部门设备数据
  orgDevice: state => state.orgTree.orgDevice,
  // 用户信息
  userInfo: state => state.user.userInfo,
  // 管理员信息
  adminInfo: state => state.user.adminInfo,
  // 未读消息数据
  unreadMsgData: state => state.message.unreadMsgData,
};

export default getters;
